import * as icons from './icons/index';

interface IconAttributes {
  accent?: string;
  className?: string;
  fill?: string;
  height?: number;
  preserveAspectRatio?: string;
  primary?: string;
  width?: number;
}

export interface IconProps extends IconAttributes {
  icon: string;
}

// Declared locally, and as possibly-undefined, because this module is compiled into browser bundles by
// consumers whose tsconfig has no node types.
declare const process: { env: { NODE_ENV?: string } } | undefined;

const warnedIcons = new Set<string>();

// Absent `process` must count as production, not as dev — the operand order below is load-bearing.
// See primitives/icon/tests/warnMissingIcon.test.ts.
const warnMissingIcon = (icon: string) => {
  const isProduction = typeof process === 'undefined' || process.env.NODE_ENV === 'production';
  if (isProduction || warnedIcons.has(icon)) return;

  warnedIcons.add(icon);
  console.warn(`Missing icon: ${icon}`);
};

const Icon = ({ icon, ...iconProps }: IconProps) => {
  if (!icon) return null;

  // @ts-ignore
  const Component = icons[icon];
  if (!Component) {
    warnMissingIcon(icon);
    return null;
  }
  return <Component {...iconProps} />;
};

export type IconType = typeof Icon;

export default Icon;
